import * as React from 'react';

const CombosIcon = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 25 31" >
      <g
        fill="#78bdf0"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M15.5.5h-12a3 3 0 00-3 3v24a3 3 0 003 3h18a3 3 0 003-3v-18z" />
        <path d="M15.5.5v9h9M18.5 17h-12M18.5 23h-12M9.5 11h-3" />
      </g>
    </svg>
  );
};

export default CombosIcon;
